var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animate-component",style:(_vm.computedStyle),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }